@if (routingInProgress$ | async) {
<ish-loading />
} @else {
<h1 class="text-center text-capitalize font-50 my-4">Customer Login</h1>
<div class="container-fluid">
  <div class="row justify-content-center" data-testing-id="account-login-page">
    <div class="col-lg-6 border p-3">
      <div class="mb-2">
        @if ((isLoggedIn$ | async) !== true) {
        <div>
          <h1 class="h2">{{ 'account.login.signin.heading' | translate }}</h1>
          @if (loginMessageKey$ | async; as loginMessageKey) {
          <p class="alert alert-info">
            {{ loginMessageKey | translate }}
          </p>
          }
          <ish-identity-provider-login />
        </div>
        <div class="row auth0-btn-wrapp">
          <div class="col-12 mb-3">
            <ish-auth0-sign-in></ish-auth0-sign-in>
          </div>
          <div class="col-12">
            <ish-azure-sign-in></ish-azure-sign-in>
          </div>
        </div>
        }
      </div>
      <div class="mb-0">
        <h2 class="registered-cutomer-header">{{ 'dias.account.new_user.heading' | translate }}</h2>
        <p>{{ 'account.create.benefit.text' | translate }}</p>
        <a class="btn btn-primary" routerLink="/register" [queryParams]="{ returnUrl: '/account' }"
          >{{ 'dias.account.create.button.label' | translate }}
        </a>
      </div>
    </div>
  </div>
</div>
}
